import React, { useEffect, useState } from 'react';
import style from '../css/Feedback.module.css';
import Navbar from '../navigation/Navbar';
import HeaderBar from './HeaderBar';
import { FaHome } from 'react-icons/fa';

function Feedback() {
	const [formData, setFormData] = useState({
		name: '',
		rating: '',
		overall_experience: 'Excellent',
		liked_most: '',
		improvement_suggestion: '',
		recommend: '',
	});

	const [responseMsg, setResponseMsg] = useState('');
	const [loading, setLoading] = useState(false); // Loading state

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	useEffect(() => {
		const user = JSON.parse(localStorage.getItem('user'));
		if (user?.name) {
			setFormData((prev) => ({
				...prev,
				name: user.name,
			}));
		}
	}, []);

	const handleSubmit = async (e) => {
		e.preventDefault();

		// Basic validation
		if (
			!formData.name ||
			!formData.rating ||
			!formData.overall_experience ||
			!formData.recommend
		) {
			setResponseMsg('Please fill in all required fields.');
			return;
		}

		setLoading(true); // Show loader

		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/insert_feedback.php',
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(formData),
				}
			);

			const result = await response.json();
			if (result.success) {
				setResponseMsg('Thank you for your feedback!');
				setFormData({
					name: '',
					rating: '',
					overall_experience: 'Excellent',
					liked_most: '',
					improvement_suggestion: '',
					recommend: '',
				});
			} else {
				setResponseMsg(result.error || 'Something went wrong.');
			}
		} catch (error) {
			setResponseMsg('Error submitting feedback.');
		} finally {
			setLoading(false); // Hide loader after submission
		}
	};

	return (
		<div>
			<HeaderBar
				text={'Feedback'}
				icon={<FaHome color="black" size={20} />}
				navi="/dashboard"
			/>

			<div className={style.feedbackForm}>
				<p className={style.feedbackTitle}>
					Your feedback is valuable to us — it helps us grow, improve, and serve
					you better every day.
				</p>
				<form onSubmit={handleSubmit}>
					<label>
						Name *:
						<input
							type="text"
							name="name"
							value={formData.name}
							onChange={handleChange}
							// readOnly
						/>
					</label>

					<label>
						Rating *:
						<div className={style.emojiRating}>
							{[1, 2, 3, 4, 5].map((num) => (
								<label key={num} className={style.emojiLabel}>
									<input
										type="radio"
										name="rating"
										value={num}
										checked={formData.rating === String(num)}
										onChange={handleChange}
										required
									/>
									<span
										className={
											formData.rating >= num ? style.selected : style.default
										}
									>
										{['😡', '😕', '😐', '😊', '🤩'][num - 1]} {/* Emoji map */}
									</span>
								</label>
							))}
						</div>
					</label>

					<label>
						Overall Experience *:
						<select
							name="overall_experience"
							value={formData.overall_experience}
							onChange={handleChange}
							required
						>
							<option value="Excellent">Excellent</option>
							<option value="Good">Good</option>
							<option value="Neutral">Neutral</option>
							<option value="Need to improve">Need to improve</option>
						</select>
					</label>

					<label>
						Message (optional)
						<textarea
							type="text"
							name="liked_most"
							value={formData.liked_most}
							onChange={handleChange}
						/>
					</label>

					<label>
						What can we improve? (optional)
						<textarea
							name="improvement_suggestion"
							value={formData.improvement_suggestion}
							onChange={handleChange}
						></textarea>
					</label>

					<label>
						Would you recommend us to others?*
						<select
							name="recommend"
							value={formData.recommend}
							onChange={handleChange}
							required
						>
							<option value="" disabled>
								-- Select an option --
							</option>
							<option value="Yes">Yes</option>
							<option value="No">No</option>
							<option value="Maybe">Maybe</option>
						</select>
					</label>

					<button type="submit" disabled={loading}>
						{loading ? 'Submitting...' : 'Submit Feedback'}
					</button>
				</form>

				{responseMsg && <p className={style.responseMsg}>{responseMsg}</p>}

				{/* Loader */}
				{loading && (
					<div className={style.loader}>
						<div className={style.spinner}></div>
						<p>Submitting...</p>
					</div>
				)}
			</div>
		</div>
	);
}

export default Feedback;
